/* eslint-disable  */
import { modalActions } from '@/Actions';
import { BaseModal } from '@/Components/Modals/BaseModal';
import { Weight } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import weight1 from '@/Images/weightImg1.png';
import weight2 from '@/Images/weightImg2.png';
import cost1 from '@/Images/costImg1.png';
import cost2 from '@/Images/costImg2.png';
import percentage1 from '@/Images/percentageImg1.png';
import percentage2 from '@/Images/percentageImg2.png';

function CalculationInfoModal() {
    const modalData = useSelector((state) => state.modal.aifmsSummaryInfoModal);
    const dispatch = useDispatch();
    const { show, data = {} } = modalData;
    const [selectedTab, setSelectedTab] = useState('weight');

    const handleClose = () => {
        dispatch(modalActions.toggleAifmsSummaryInfoModal(false));
        setSelectedTab('weight');
    }
    const tabs = [
        { id: 'weight', label: 'Weight', icon: <Weight size={12} /> },
        { id: 'cost', label: 'Cost', icon: '$' },
        { id: 'percentage', label: 'Percentage', icon: '%' }
    ];

    const renderData = () => {
        switch (selectedTab) {
            case 'weight':
                return (
                <div className = 'mt-3 flex flex-col gap-3'>
                    <div><img src={weight1} className='w-full h-full' alt='weight' /></div>
                    <div><img src={weight2} className='w-full h-full' alt='weight' /></div>
                </div>
            )
            case 'cost':
                return (
                <div className = 'mt-3 flex flex-col gap-3'>
                    <div><img src={cost1} className='w-full h-full' alt='cost' /></div>
                    <div><img src={cost2} className='w-full h-full' alt='cost' /></div>
                </div>
                )
            case 'percentage':
                return (
                <div className = 'mt-3 flex flex-col gap-3'>
                <div><img src={percentage1} className='w-full h-full' alt='percentage' /></div>
                <div><img src={percentage2} className='w-full h-full' alt='percentage' /></div>
            </div>
            )
        }   
        return null;
    }
    return (
        <BaseModal
            open={show}
            handleClose={handleClose}
            width='700px'
            height='550px'
            hideFooter={true}
        >
            <div className='pt-6 px-6 pb-0 text-left'>
                <div>
                    <div className='font-semibold text-[18px] text-[#222]'>
                        Recipe Weight Calculation Guide
                    </div>
                    <div className='text-[14px] text-gray-500 mt-1'>
                        Details on how fulfilled &amp; ordered weight are derived for each ingredient.
                    </div>
                </div>
                <div>
                    <div className='flex gap-2 mt-3 bg-slate-200 text-black hover:bg-slate-300 rounded-lg'>
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setSelectedTab(tab.id)}
                                className={`px-4 py-2 m-1 flex flex-1 justify-center items-center gap-2 rounded-md text-sm font-medium transition-colors ${tab.id === selectedTab
                                    ? 'bg-yellow-200 text-black'
                                    : ''
                                    }`}
                            >
                                <span className='mr-2'>{tab.icon}</span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                    {renderData()}
                </div>
            </div>
        </BaseModal>
    );
}

export default CalculationInfoModal;
